import React,{useContext, useEffect} from 'react';

//Import Components
import { ThemeContext } from "../../config/context/ThemeContext";
import Stats from "./Dashboard/Stats";



const Home = () => {
	const { changeBackground } = useContext(ThemeContext);
	useEffect(() => {
		changeBackground({ value: "light", label: "Light" });
	}, []);
	return(
		<>
			<div className="row">
				<div className="col-xl-12">
					<div className="row">
						<div className="col-xl-12">
							<div className="row">
								<div className="col-md-12 col-sm-6">
									<div className="card booking">
										<div className="card-body">
											<div className="booking-status d-flex align-items-center">
												<div className="">
													<h2 className="mb-0 font-w600">Welcome at Knaek admin </h2>

												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

						<Stats/>
						</div>

					</div>
				</div>
			</div>
		</>
	)
}
export default Home;
